import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface StepData {
  currentStep: number;
  totalSteps: number;
  currentStepLabel: string;
  nextStepLabel: string;
}

@Component({
  selector: 'app-step-indicator',

  imports: [CommonModule],
  template: `
    <div class="flex items-center space-x-4 mb-4 xl:mb-6">
      <!-- Indicador circular con SVG -->
      <div class="relative w-12 h-12">
        <svg class="w-12 h-12 transform -rotate-90" viewBox="0 0 44 44">
          <!-- Círculo de fondo -->
          <circle
            cx="22"
            cy="22"
            r="20"
            stroke="#e5e7eb"
            stroke-width="3"
            fill="none"
            class="opacity-20"
          />
          <!-- Círculo de progreso -->
          <circle
            cx="22"
            cy="22"
            r="20"
            stroke="#003f87"
            stroke-width="3"
            fill="none"
            [attr.stroke-dasharray]="circumference"
            [attr.stroke-dashoffset]="strokeDashoffset"
            class="transition-all duration-300 ease-in-out"
            stroke-linecap="round"
          />
        </svg>
        <div class="absolute inset-0 flex items-center justify-center">
          <span class="text-sm font-semibold text-gray-700">
            {{ stepData.currentStep }}/{{ stepData.totalSteps }}
          </span>
        </div>
      </div>

      <!-- Información del paso -->
      <div class="flex-1">
        <h2 class="text-lg font-semibold text-gray-800 fs-condensed">
          {{ stepData.currentStepLabel }}
        </h2>
        <p class="text-sm text-gray-500">
          Siguiente: {{ stepData.nextStepLabel }}
        </p>
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class StepIndicatorComponent {
  @Input() stepData!: StepData;

  get circumference(): number {
    return 2 * Math.PI * 20; // radio de 20
  }

  get percentage(): number {
    return (this.stepData.currentStep / this.stepData.totalSteps) * 100;
  }

  get strokeDashoffset(): number {
    return this.circumference - (this.percentage / 100) * this.circumference;
  }
}
